import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { VictoryAxis, VictoryChart, VictoryLine, VictoryTheme } from "victory";
import ChartLabel from "../../../../../components/ChartLabel";
import { langDashCodesDictionary } from "../../../../../constants";

const Chart = ({ data }) => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;

	const tickFormat = (date) => {
		const nDate = new Date(date);
		return nDate
			.toLocaleDateString(langDashCodesDictionary[lang] || "pl-PL", {
				month: "numeric",
				year: "numeric",
			})
			.replaceAll(".", "-");
	};

	return (
		<Grid container rowSpacing={5}>
			<Grid size={6}>
				<Box>
					<ChartLabel text={t("cargos_entered_chart")} color="#000" />
					<VictoryChart
						theme={VictoryTheme.material}
						scale={{ x: "linear" }}
						width={1000}
						height={300}
					>
						<VictoryAxis
							style={{
								axisLabel: { padding: 30 },
								tickLabels: { angle: 60, padding: 20 },
							}}
							tickFormat={tickFormat}
							tickCount={10}
						/>
						<VictoryAxis
							dependentAxis
							tickFormat={(t) =>
								Intl.NumberFormat("en-US", {
									notation: "compact",
									maximumFractionDigits: 1,
								}).format(t)
							}
						/>
						<VictoryLine
							data={data}
							labels={({ datum }) =>
								Intl.NumberFormat("en-US", {
									notation: "compact",
									maximumFractionDigits: 2,
								}).format(datum._y)
							}
							x="date"
							y="entered"
							style={{ data: { stroke: "#000" } }}
						/>
					</VictoryChart>
				</Box>
			</Grid>
			<Grid size={6}>
				<Box>
					<ChartLabel text={t("cargos_sold_chart")} color="#AE78D6" />
					<VictoryChart
						theme={VictoryTheme.material}
						scale={{ x: "linear" }}
						width={1000}
						height={300}
					>
						<VictoryAxis
							style={{
								axisLabel: { padding: 30 },
								tickLabels: { angle: 60, padding: 20 },
							}}
							tickFormat={tickFormat}
							tickCount={10}
						/>
						<VictoryAxis
							dependentAxis
							tickFormat={(t) =>
								Intl.NumberFormat("en-US", {
									notation: "compact",
									maximumFractionDigits: 1,
								}).format(t)
							}
						/>
						<VictoryLine
							data={data}
							labels={({ datum }) =>
								Intl.NumberFormat("en-US", {
									notation: "compact",
									maximumFractionDigits: 2,
								}).format(datum._y)
							}
							x="date"
							y="sold"
							style={{ data: { stroke: "#AE78D6" } }}
						/>
					</VictoryChart>
				</Box>
			</Grid>
			<Grid size={6}>
				<Box>
					<ChartLabel text={t("total_margin") + " (€)"} color="#ADDB7B" />
					<VictoryChart
						theme={VictoryTheme.material}
						scale={{ x: "linear" }}
						width={1000}
						height={300}
					>
						<VictoryAxis
							style={{
								axisLabel: { padding: 30 },
								tickLabels: { angle: 60, padding: 20 },
							}}
							tickFormat={tickFormat}
							tickCount={10}
						/>
						<VictoryAxis
							dependentAxis
							tickFormat={(t) =>
								Intl.NumberFormat("en-US", {
									notation: "compact",
									maximumFractionDigits: 1,
								}).format(t)
							}
						/>
						<VictoryLine
							data={data}
							labels={({ datum }) =>
								Intl.NumberFormat("en-US", {
									notation: "compact",
									maximumFractionDigits: 2,
								}).format(datum._y)
							}
							x="date"
							y="margin"
							style={{ data: { stroke: "#ADDB7B" } }}
						/>
					</VictoryChart>
				</Box>
			</Grid>
			<Grid size={6}>
				<Box>
					<ChartLabel text={t("average_margin") + " (€)"} color="#F07C00" />
					<VictoryChart
						theme={VictoryTheme.material}
						scale={{ x: "linear" }}
						width={1000}
						height={300}
					>
						<VictoryAxis
							style={{
								axisLabel: { padding: 30 },
								tickLabels: { angle: 60, padding: 20 },
							}}
							tickFormat={tickFormat}
							tickCount={10}
						/>
						<VictoryAxis
							dependentAxis
							tickFormat={(t) =>
								Intl.NumberFormat("en-US", {
									notation: "compact",
									maximumFractionDigits: 1,
								}).format(t)
							}
						/>
						<VictoryLine
							data={data}
							labels={({ datum }) =>
								Intl.NumberFormat("en-US", {
									notation: "compact",
									maximumFractionDigits: 2,
								}).format(datum._y)
							}
							x="date"
							y="income"
							style={{ data: { stroke: "#F07C00" } }}
						/>
					</VictoryChart>
				</Box>
			</Grid>
		</Grid>
	);
};

export default Chart;
